import { promoValidFromToFormat } from '@diamond/shared/utils';

import { formatDiscountDisplay } from '../banners/format-discount-display';
import { ItemInfo, OrderDetailData } from '../promos/promos';

export interface PromoItemForCard {
  type: 'discount' | 'free-item' | 'cashback';
  duration: string;
  text: string;
  promoId: string;
  item?: ItemInfo;
  images?: string[]; // Product images for CardPromoInfo
  discountDisplay?: string; // Discount percentage text for CardPromoInfo
}

type PromoType = OrderDetailData[number]['promos'];

export function buildDivisionPromos(promos: PromoType): PromoItemForCard[] {
  const result: PromoItemForCard[] = [];
  const seenPromoIds = new Set<string>();

  const freeGoodPromos = [
    ...(promos.single_free_good_promos || []),
    ...(promos.bundled_free_good_promos || []),
  ];

  freeGoodPromos.forEach((promo) => {
    // Deduplicate by promo.id - same promo can apply to multiple products
    if (seenPromoIds.has(promo.id)) {
      return;
    }
    seenPromoIds.add(promo.id);

    result.push({
      type: 'free-item',
      duration: promoValidFromToFormat(promo.valid_from, promo.valid_until),
      text: promo.mechanism || '',
      promoId: promo.id,
      images: promo.product_images_medium?.length
        ? promo.product_images_medium
        : undefined, // Extract images array for CardPromoInfo
      item: {
        id: promo.product_id,
        price: promo.price || 0,
        img: promo.product_images_medium?.[0] || '',
        qty: (promo.quantity_free_goods || 0) / 1000,
        uom: promo.sales_unit_desc || '',
      },
    });
  });

  const discountPromos = [
    ...(promos.single_discount_promos || []),
    ...(promos.bundled_discount_promos || []),
  ];

  discountPromos.forEach((promo) => {
    // Deduplicate by promo.id - same promo can apply to multiple products
    if (seenPromoIds.has(promo.id)) {
      return;
    }
    seenPromoIds.add(promo.id);

    if (promo.is_discount) {
      let discountDisplay: string | undefined;
      if (
        typeof promo.deduction_amount === 'number' &&
        typeof promo.is_discount === 'boolean'
      ) {
        discountDisplay = formatDiscountDisplay(
          promo.deduction_amount,
          promo.is_discount
        );
      }

      result.push({
        type: 'discount',
        duration: promoValidFromToFormat(promo.valid_from, promo.valid_until),
        text: promo.mechanism || '',
        promoId: promo.id,
        discountDisplay,
      });
    } else {
      result.push({
        type: 'cashback',
        duration: promoValidFromToFormat(promo.valid_from, promo.valid_until),
        text: promo.mechanism || '',
        promoId: promo.id,
      });
    }
  });

  return result;
}
